<div class="modal-header">
  <h4 class="modal-title">Потвърждение на наддаването</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    [disabled]="loading"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body" nzForceRepaint>
  <p><strong class="text-muted">Артикул: </strong>{{ adDetails.title }}</p>
  <p><strong class="text-muted">Текуща цена:</strong> {{ adDetails.price.toFixed(2) }} лв.</p>
  <p><strong class="text-muted">Минимална стъпка:</strong> {{ adDetails.bidIncrement.toFixed(2) }} лв.</p>
  <p><strong class="text-muted">Потребител:</strong> {{ currentUser.userData?.username }}</p>
  <hr>
  <form [formGroup]="form">
    <fieldset class="mb-3">
      <label for="amount" class="mb-0 form-label">Наддаване*</label>
      <input
        id="amount"
        type="number"
        formControlName="amount"
        class="form-control"
        [placeholder]="'Минимум ' + minBidAmount.toFixed(2) + ' лв.'"
        aria-label="Наддаване"
        [class.is-valid]="amount?.touched && amount?.valid"
        [class.is-invalid]="amount?.touched && amount?.invalid">
      <p class="invalid-feedback m-0">Минимум {{ minBidAmount.toFixed(2) }} лв!</p>
    </fieldset>
    @if (!!currentUser.userData) {
      @if (currentUser.userData.confirmationMethod === UserConfirmationMethod.Password) {
        <fieldset class="form-group mt-3">
          <label for="password">Парола*</label>
          <input
            id="password"
            type="password"
            formControlName="password"
            class="form-control"
            placeholder="Въведете парола..."
            aria-label="Парола"
            [class.is-valid]="password?.touched && password?.valid"
            [class.is-invalid]="password?.touched && password?.invalid">
          <p class="invalid-feedback m-0">Задължително поле!</p>
        </fieldset>
      } @else if (currentUser.userData.confirmationMethod === UserConfirmationMethod.Pin) {
        <fieldset class="form-group">
          <label for="pin">ПИН код*</label>
          <input
            id="pin"
            type="password"
            formControlName="pin"
            class="form-control"
            placeholder="Въведете ПИН..."
            aria-label="ПИН"
            [class.is-valid]="pin?.touched && pin?.valid"
            [class.is-invalid]="pin?.touched && pin?.invalid">
          <p class="invalid-feedback m-0">Задължително поле!</p>
        </fieldset>
      }
    }
  </form>
  <div class="mb-2 mt-4 alert alert-warning">
    <small>
      С потвърждаването на наддаването декларирам, че приемам
      <button class="p-0 btn btn-sm btn-link text-decoration-none align-baseline"
              (click)="closeModal([appRoutes.root, appRoutes.termsConditions])">
        Общите условия
      </button>
      на сайта, както и условията, посочени от продавача.
    </small>
  </div>
  @if (!!errorMessage) {
    <div class="mt-3 text-danger">
      {{ errorMessage }}
    </div>
  }
</div>
<div class="modal-footer">
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-outline-secondary"
    (click)="closeModal()">
    <span>Затвори</span>
  </button>
  <button
    type="button"
    [disabled]="loading"
    class="btn btn-nz-primary"
    (click)="onSubmit()">
    @if (loading) {
      <span class="me-2 spinner-border spinner-border-sm"></span>
    }
    <span>Потвърди</span>
  </button>
</div>
